import { addDoubleQuotes } from '../utils/smartutils';

export function productListByFilter(filter) {
  const query = `{productListByFilter(filter:  ${JSON.stringify(filter).replace(
    /"([^(")"]+)":/g,
    '$1:'
  )}) {id, name, description, value, category{id, name}, active}}`;
  return query;
}

export function saveProductMutation(values) {
  const mutationQuery = `mutation { 
    productSave(
        product: 
            {
                id: ${values.id ? values.id : 0},
                name: "${values.name}",                
                description: ${addDoubleQuotes(values.description)},
                value: ${values.value}
                category: {
                    id: ${values.category.id},
                    filterByStatus: false,
                    updaterId:0,
                    active:true
                },                
                active: ${values.active},
                filterByStatus:false,
                updaterId:0
            }
        ), {id}
    }`;
  return mutationQuery;
}

export function removeProductMutation(id) {
  const query = `mutation {productRemove(id: ${id})}`;
  return query;
}
